export default "__VITE_ASSET__a7335939__"